import React from 'react';

const LocationCard = ({ location }) => {
  return (
    <div className="w-full md:w-1/2 md:pl-4 mb-5">
      <div className="h-76 bg-white rounded px-6 py-10">
        <h1 className="text-4xl font-bold mb-3">Location Info</h1>
        <ul>
          <li className="py-1">
            Name - <span className="text-sm">{location.name}</span>
          </li>
          <li className="py-1">
            State/Region - <span className="text-sm">{location.state}</span>
          </li>
          <li className="py-1">
            Country - <span className="text-sm">{location.country}</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LocationCard;
